import { render, staticRenderFns } from "./AreaFormFields.vue?vue&type=template&id=34b21ecc&scoped=true&"
import script from "./AreaFormFields.vue?vue&type=script&lang=js&"
export * from "./AreaFormFields.vue?vue&type=script&lang=js&"
import style0 from "./AreaFormFields.vue?vue&type=style&index=0&id=34b21ecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b21ecc",
  null
  
)

export default component.exports